import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftDeliveryCategoryCreate,
  GiftDeliveryCategoryData,
  GiftDeliveryCategoryUpdate,
} from './giftDeliveryCategory.interface';

export const createGiftDeliveryCategory = async (
  data: GiftDeliveryCategoryCreate,
  role: LowerRole,
): Promise<GiftDeliveryCategoryData> => {
  const res = await api_.post(`/${role}/gift-delivery-category`, data);
  return res.data;
};

export const updateGiftDeliveryCategory = async (
  id: string,
  data: GiftDeliveryCategoryUpdate,
  role: LowerRole,
): Promise<GiftDeliveryCategoryData> => {
  const res = await api_.patch(`/${role}/gift-delivery-category/${id}`, data);
  return res.data;
};

export const deleteGiftDeliveryCategory = async (
  id: string,
  role: LowerRole,
): Promise<void> => {
  await api_.delete(`/${role}/gift-delivery-category/${id}`);
};
